import React from 'react'
import {Row,Col,Button,Icon,Breadcrumb} from 'antd'
import {Link} from 'react-router-dom'
import Image from './Image'
import Tags from './Tags'
//import * as API from './API'
import * as Util from '../util/Util'
import Timeago from '../Timeago'

//const TYPE = 'Post'

export default class Post extends React.Component {
  state={}
  componentDidMount() {

  }
  renderBreadcrumb() {
    const {content} = this.props
    if (typeof(content)==='object'&&content!==null) {
      const {name} = content
      return (
        <Breadcrumb className="color-white text-shadow">
          <Breadcrumb.Item><Link to="/"><Icon type="home" className="mr-2" /> Home</Link></Breadcrumb.Item>
          <Breadcrumb.Item>{name}</Breadcrumb.Item>
        </Breadcrumb>
      )
    }
    return null
  }
  handleNav=()=>{
    const {onChange} = this.props
    if (typeof(onChange)==='function') {
      onChange()
    }
  }
  renderPrev() {
    const {prev} = this.props
    if (typeof(prev)==='object'&&prev!==null) {
      const {name,_slug} = prev
      const to = `/post/${_slug}`
      return (
        <Link to={to} onClick={this.handleNav}>
          <Button ghost size="small" className="mb-2"><Icon type="left" />{name}</Button>
        </Link>
      )
    }
    return null
  }
  renderNext() {
    const {next} = this.props
    if (typeof(next)==='object'&&next!==null) {
      const {name,_slug} = next
      const to = `/post/${_slug}`
      return (
        <Link to={to} className="float-right" onClick={this.handleNav}>
          <Button ghost size="small">{name}<Icon type="right" /></Button>
        </Link>
      )
    }
    return null
  }
  renderNavigator() {
    return (
      <Row className="content-navigator mb-3">
        <Col xs={24} sm={12} md={12} lg={12}>
          {this.renderPrev()}
        </Col>
        <Col xs={24} sm={12} md={12} lg={12}>
          {this.renderNext()}
        </Col>
      </Row>
    )
  }
  renderTitle() {
    const {content} = this.props
    if (typeof(content)==='object'&&content!==null) {
      const {name} = content
      return (
        <h1 className="text-center content-title text-shadow">{name}</h1>
      )
    }
    return null
  }
  renderContent() {
    const {t,content} = this.props
    if (typeof(content)==='object'&&content!==null) {
      //const {_id,_slug,_type,name,lead,created,body,footer,tags,images,caption,notes,properties} = content
      const {lead,created,body,footer,tags,images,notes} = content
      return (
        <div className="main-content mb-4">
          <p className="lead" dangerouslySetInnerHTML={Util.fromMd(lead)} />
          <Timeago t={t} value={new Date(created)} className="mb-3" />
          <Tags
            className="mb-2"
            type={'tag'}
            values={tags}
            //match={match}
            //onTag={onTag}
          />
          <Image {...images} className="content-image text-center mb-3" />
          <p className="body" dangerouslySetInnerHTML={Util.fromMd(body)} />
          <p className="footer" dangerouslySetInnerHTML={Util.fromMd(footer)} />
          <blockquote className="blockquote text-right">
            <footer className="blockquote-footer" dangerouslySetInnerHTML={Util.fromMd(notes)} />
          </blockquote>
        </div>
      )
    }
    return null
  }
  render() {
    return (
      <div className="cms-content">
        {this.renderBreadcrumb()}
        {this.renderTitle()}
        {this.renderNavigator()}
        {this.renderContent()}
        {this.renderNavigator()}
      </div>
    )
  }
}
